// Import Swiper and modules
import Swiper, { Navigation, Pagination } from "swiper";

export const usps = () => {
  const breakpoint = window.matchMedia("(min-width:1024px)");

  const uspsSections = document.querySelectorAll(".usp");

  if (uspsSections) {
    const uspsSwiper = document.querySelector("#uspSwiper");
    const swiperConfig = {
      modules: [Navigation, Pagination],
      direction: "horizontal",
      speed: 1000,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 12,
      breakpoints: {
        768: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 32,
        },
      },
    };

    const enableSwiper = new Swiper(uspsSwiper, swiperConfig);
    return enableSwiper;
  }
};

export default usps;
